import { render, staticRenderFns } from "./InviteBtn.vue?vue&type=template&id=58673574&"
import script from "./InviteBtn.vue?vue&type=script&lang=js&"
export * from "./InviteBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports